import React from "react";
import "./contact-link.scss";
import RenderCellContent from "../mui-table/render-cell-content";
import { leadLinkActivityLog } from "../../../api/lead";
import { customerLinkActivityLog } from "../../../api/customer";

type ContactType = "Email" | "Phone" | "website" | "SMS";

type ContactLinkProps = {
  type: ContactType;
  value: string;
  className?: string;
  id?: any;
  isCustomer?: boolean;
  setSendSmsPopupOpen?: (open: boolean) => void;
};

const ContactLink: React.FC<ContactLinkProps> = ({
  type,
  value,
  className,
  id,
  isCustomer = false,
  setSendSmsPopupOpen,
}) => {
  if (!value) return null;

  const handleActivityLog = async () => {
    try {
      const payload = {
        contactValue: value,
        contactType: type === "Phone" ? "Call" : type,
      };
      if (isCustomer) {
        await customerLinkActivityLog(id, payload);
      } else {
        await leadLinkActivityLog(id, payload);
      }
    } catch (error) {
      console.error(error);
    }
  };

  let href = "";
  let onClickHandler = undefined;
  if (type === "SMS") {
    onClickHandler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      if (setSendSmsPopupOpen) setSendSmsPopupOpen(true);
    };
  } else {
    switch (type) {
      case "Email":
        href = `mailto:${value}`;
        break;
      case "Phone":
        href = `tel:${value}`;
        break;
      case "website":
        href =
          value.startsWith("http://") || value.startsWith("https://")
            ? value
            : `https://${value}`;
        break;
      default:
        return null;
    }
    onClickHandler = () => {
      if (id) handleActivityLog();
    };
  }

  return (
    <>
      {value === "-" ? (
        <div>{value}</div>
      ) : (
        <a
          href={type === "SMS" ? undefined : href}
          target={type === "website" ? "_blank" : undefined}
          rel={type === "website" ? "noopener noreferrer" : undefined}
          className={`contact-link ${className || ""}`}
          onClick={onClickHandler}
        >
          <RenderCellContent text={value} />
        </a>
      )}
    </>
  );
};

export default ContactLink;
